import { useState } from 'react';
import { useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import { createEmptyArtifact } from '../../createEmptyArtifact';
import { FormValues } from '../../types';

/** Owns which artifact is being edited and the add/remove/rekey logic for the artifact list. */
export function useArtifactList(setArtifactCount?: (count: number) => void) {
  const { values, setValues } = useFormikContext<FormValues>();
  const [activeIndex, setActiveIndex] = useState(0);
  const [artifactKeys, setArtifactKeys] = useState(() =>
    values.artifacts.map(() => uuidv4())
  );

  return {
    activeIndex,
    activate: setActiveIndex,
    artifactKeys,
    addArtifact,
    removeArtifact,
  };

  function addArtifact() {
    setValues((prev) => {
      const artifacts = [...prev.artifacts, createEmptyArtifact()];
      setArtifactKeys((prevKeys) => [...prevKeys, uuidv4()]);
      setActiveIndex(artifacts.length - 1);
      setArtifactCount?.(artifacts.length);
      return { ...prev, artifacts };
    });
  }

  function removeArtifact(index: number) {
    setValues((prev) => {
      const removedName = prev.artifacts[index].name;
      const artifacts = prev.artifacts
        .filter((_, i) => i !== index)
        .map((artifact) => ({
          ...artifact,
          dependencies: artifact.dependencies.filter(
            (dependency) => dependency !== removedName
          ),
        }));
      setArtifactKeys((prevKeys) => prevKeys.filter((_, i) => i !== index));
      setActiveIndex((prevIndex) =>
        prevIndex >= index && prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
      setArtifactCount?.(artifacts.length);
      return { ...prev, artifacts };
    });
  }
}
